import React from 'react';
import './PermitTemplate.css';

// This component is purely for PDF generation.
// It will be rendered off-screen.
function PermitTemplate({ appData, qrCodeDataURL, forwardedRef }) {

  // This inner component renders one copy of the permit
  const PermitCopy = ({ copyType }) => (
    <div className="pdf-box">
      <div className="permit-form">
        <table className="permit-table">
          <thead>
            <tr>
              <th colSpan="4" className="header">
                <div className="header-content">
                  <div>Department of Mines and Geology</div>
                  <div>Mineral Dispatch Permit</div>
                  <div>See Rule 42(3) of KMMCR-1994)</div>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="label" style={{ width: '22%' }}>MDRO No</td>
              <td className="value" style={{ width: '30%' }}>{appData.mdroNo}</td>
              <td className="label" style={{ width: '13%' }}>Sr No. {appData.srNo}</td>
              {/* <td className="value" style={{ width: '30%' }}>{appData.srNo}</td> */}
              <td rowSpan="8" className="seal-column" style={{ width: '35%' }}>
                <div className="seal-text">Sign & Seal of Lease</div>
              </td>
            </tr>
            <tr>
              <td className="label">MDP No</td>
              <td colSpan="2" className="value">
                {appData.mdpNo}
                {/* {appData.mdpNoPart1} {appData.mdpNoPart2} */}
              </td>
            </tr>
            <tr>
              <td className="label">Lease No</td>
              <td className="value">{appData.leaseNoPart1}</td>
              <td className="value">
                {/* === THIS IS THE CHANGE === */}
                <div>Barcode : {appData.barcode}</div>
                {/* <div>{appData.leaseNoPart2}</div>
                {/* ========================= */}
              </td>
            </tr>
            <tr>
              <td className="label">Lease Name</td>
              <td className="value">{appData.leaseName}</td>
              <td className="value">Type of Land: {appData.landType}</td>
            </tr>
            <tr>
              <td className="label">DSC No / Name</td>
              <td className="value">{appData.dscName}</td>
              <td className="value">GST No. : {appData.gstNo}</td>
            </tr>
            <tr>
              <td className="label">Taluk / District</td>
              <td colSpan="2" className="value">{appData.district}</td>
            </tr>
            <tr>
              <td className="label">Place of Loading</td>
              <td colSpan="2" className="value">{appData.loadingPlace}</td>
            </tr>
            <tr>
              <td className="label">MDRO Purpose</td>
              <td colSpan="2" className="value">{appData.purpose}</td>
            </tr>
            <tr>
              <td className="label">Mineral / Grade</td>
              <td colSpan="2" className="value">{appData.mineral}</td>
              <td rowSpan="5" className="seal-column">
                <div className="seal-text">Sign & Seal of Lease</div>
              </td>
            </tr>
            <tr>
              <td className="label">Quantity (Tonnes)</td>
              <td colSpan="2" className="value">{appData.quantity}</td>
            </tr>
            <tr>
              <td className="label">Total Amount Paid</td>
              <td colSpan="2" className="value">{appData.amount}</td>
            </tr>
            <tr>
              <td className="label">Buyer</td>
              <td colSpan="2" className="value">
                <div>{appData.buyerLine1}</div>
                <div>{appData.buyerLine2}</div>
              </td>
            </tr>
            <tr>
              <td className="label">Route</td>
              <td colSpan="2" className="value">
                <div>{appData.routeLine1}</div>
                <div>{appData.routeLine2}</div>
              </td>
            </tr>
            <tr>
              <td className="label">Check Post</td>
              <td colSpan="2" className="value">{appData.checkPost}</td>
              <td rowSpan="6" className="qr-column">
                <div className="qr-code">
                  {/* Using the pre-generated QR code image data */}
                  {qrCodeDataURL && <img src={qrCodeDataURL} alt="QR Code" />}
                </div>
                <div className="qr-label">{copyType}</div>
              </td>
            </tr>
            <tr>
              <td className="label">Destination</td>
              <td colSpan="2" className="value">{appData.destination}</td>
            </tr>
            <tr>
              <td className="label">Vehicle No/No of wheels/type/mobile No</td>
              <td colSpan="2" className="value">{appData.vehicleInfo}</td>
            </tr>
            <tr>
              <td className="label">Validity</td>
              <td colSpan="2" className="value">{appData.validity}</td>
            </tr>
            <tr>
              <td className="label">Distance</td>
              <td colSpan="2" className="value">{appData.distance}</td>
            </tr>
            <tr>
              <td colSpan="3" className="note-section">
                <div className="note-title">Note:</div>
                <div className="note-content">
                  <div>This Permit is not transferable.</div>
                  <div>Thr MDP is Valid only if the mineral is transporte in aVehicle Which has required carrying</div>
                  <div>Capacity as per M.V act 1988</div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );

  return (
    <div ref={forwardedRef} className="pdf-container">
      {/* Render two copies side-by-side */}
      <PermitCopy copyType="Leaseholder copy" />
      <PermitCopy copyType="Destination copy" />
    </div>
  );
}

export default PermitTemplate;